import {message} from '@sail/intl';
import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const messages = {
  errorText: message({
    id: 'connectEmbed.disputes.errorBoundary.text',
    defaultMessage:
      'Your money is secure, but your disputes information cannot be loaded here.',
    description: 'Message shown when an unhandled disputes error is caught',
  }),
};

export const DisputesListConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "disputesExperience" */ '../../../components/Disputes/Disputes'
    ),
  messageOverrides: messages,
  releaseState: 'ga',
  enabledKey: 'disputes_list',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: 'Displays the list of disputes, allows for dispute management.',
  friendlyName: 'Disputes list',
  enabledOverrideFlag: ComponentOverrideFlag.disputes_list,
  docSitePath: 'connect/supported-embedded-components/disputes-list',
  syntheticTestInfo: {
    testUrl: 'https://amp.corp.stripe.com/synthetics/us-west-2/disputes-list',
  },
};
